import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {HashRouter} from "react-router-dom";
import {Provider} from "./lib/AppContext";
import {MaterialUIControllerProvider} from "./context";
import {CartProvider} from "./lib/CartProvider";
import {UserProvider} from "./lib/UserProvider";
import {MenuProvider} from "./lib/MenuProvider";
import {CompanyProvider} from "./lib/CompanyProvider";
import {setAppCookie} from "./app/common/appCookie";
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {CONSTANTS} from "./app/common/constants";
import {getThemeVariant} from "./app/common/themeVariant";

const root = ReactDOM.createRoot(document.getElementById('root'));
const companyGuid = document.getElementById('PSB_CID')?.getAttribute('site-id') || '';
const subdomain = document.getElementById('PSB_SUB')?.getAttribute('subdomain-id') || '';

if (companyGuid != null && companyGuid?.length > 30) {
  setAppCookie('PSB_CID', companyGuid);
}

// Embeds opt into the standard (close-to-original, white background) theme
// via a <div id="PSB_THEME" theme-id="standard"></div> marker, same pattern
// as PSB_CID / PSB_SUB above. This toggles the plain-CSS half of that theme
// (psb-helpers.scss reads the class below); colors.js separately reads the
// same marker to pick the matching MUI palette.
const themeVariant = getThemeVariant();
document.documentElement.classList.toggle('psb-theme-standard', themeVariant === 'standard');
const defaultBodyBg = themeVariant === 'standard' ? '#ffffff' : '#FBF7EE';

root.render(
  <div id={'psb-root-wrapper'} style={{
    background: CONSTANTS.SITE_OPTIONS?.body?.bgColor || defaultBodyBg,
  }}>
    <HashRouter>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MaterialUIControllerProvider>
          <CompanyProvider subdomain={subdomain}>
            <CartProvider>
              <UserProvider>
                <MenuProvider>
                  <Provider>
                    <App appMode={CONSTANTS.SITE_OPTIONS?.mode}/>
                  </Provider>
                </MenuProvider>
              </UserProvider>
            </CartProvider>
          </CompanyProvider>
        </MaterialUIControllerProvider>
      </LocalizationProvider>
    </HashRouter>
  </div>
);